import styles from './style.postcss';

import React from 'react';
import NormalTd from '../NormalTd';
import { Link } from 'react-router';
import { Icon } from 'omni-common-ui';
import PropTypes from 'prop-types';

const DetailLinkTd = (props) => <NormalTd>
  <div className={styles.DetailLinkTd_content}>
    <Link to={props.url}
        draggable={false}>
      <Icon id="arrow-right" className={styles.DetailLinkTd_arrowRight} />
    </Link>
  </div>
</NormalTd>;

DetailLinkTd.propTypes = {
  url: PropTypes.string.isRequired,
};

export default DetailLinkTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/DetailLinkTd/index.jsx